import { NotificationsActive } from "../../../common/svg/NotificationsActive";
import { JSX } from "react";

export const NotificationsHeader = (): JSX.Element => {
    return (
        <section className="p-notifications__header">
            <div className="c-breadcrumbs">
                <span>Dashboards / Meldingen</span>
            </div>
            <div className={"p-notifications__header__title"}>
                <NotificationsActive />
                <h1>Belangrijke meldingen</h1>
            </div>
        </section>
    );
};
